import HeroHomeV2 from './HeroHomeV2'
export default HeroHomeV2
